export const AUTOMOBILE_CSIO_GENDER_REVERSE = [
  "Female",
  "Male",
  "Unknown",
  "Other",
  "Unspecified",
];

export const AUTOMOBILE_CSIO_MERTIAL_STATUS_REVERSE = [
  "Common-law",
  "Divorced",
  "Married",
  "Separated",
  "Single",
  "Widowed",
];

export const AUTOMOBILE_CSIO_LICENSE_STATUS_REVERSE = [
  "In-force or Permanent",
  "Suspended",
  "Cancelled or Revoked",
  "Pending",
  "Temporary",
  "Lapsed",
  "Other",
];

export const AUTOMOBILE_CSIO_VEHICLE_BODY_TYPE_REVERSE = [
  "Ambulance",
  "Ambulance (DEPRECATED)",
  "Bus",
  "Catering Truck",
  "Compactor",
  "Casket Wagon",
  "Dump Truck",
  "Fork Lift",
  "Hearse",
  "Lugger",
  "Limousine",
  "Mini Van",
  "Other/Multi-Purpose Vehicle",
  "Pickup Truck",
  "Ready Mix Truck",
  "Rolloff Truck",
  "Road Tractor Only",
  "Road Tractor with Trailer",
  "Stake or Platform Truck",
  "Stake or Platform Truck (DEPRECATED)",
  "Sport Utility Vehicle - Small and Medium (Hard Top)",
  "Sport Utility Vehicle - Large",
  "Truck - Heavy",
  "Truck - Medium",
  "Truck - Light",
  "Tank Truck Non-pressurized",
  "Tank Truck Pressurized",
  "Tow Truck with Platform",
  "Farm Tractor",
  "Tow Truck with Wrecker",
  "Taxi",
  "Van - Heavy",
  "Van - Light",
  "3 Wheel Motorcycle",
  "3 Wheel Scooter",
  "Adventure",
  "Cabin/Home - Fifth Wheel",
  "Class A",
  "Class B",
  "Class C",
  "Cruiser",
  "Deep snow / Mountain",
  "Dual Purpose",
  "Enduro",
  "Heavy Duty",
  "Hybrid / Crossover",
  "Junior",
  "Lite",
  "Monoski",
  "Motard / Super Motard",
  "Naked Sport",
  "Off Road",
  "Off Road Motocross",
  "Off Road Trials",
  "Performance",
  "Recreational",
  "Recreational Utility",
  "Sport",
  "Sport Touring",
  "Standard",
  "Standard Sidecar",
  "Touring",
  "Trail / Sport",
  "Unknown",
  "Utility",
  "Entry Sport",
  "Entry Naked Sport",
  "Super Sport",
  "Naked Super Sport",
  "All Terrain Cycle",
  "All Terrain Tricycle",
  "All Terrain Vehicle (Four Wheel)",
  "Antique Auto (Regular Plate)",
  "Antique Auto (Historic Plate)",
  "All Terrain Vehicle",
  "Detachable Camper Body",
  "Classic/Customized Auto",
  "Camper Van",
  "Dune Buggy",
  "Golf Cart",
  "Kit Car",
  "Motorized Bicycle",
  "Motorcycles over 50 cc",
  "Motor Home (Recreational Use)",
  "Mini-bike, Trail Bike (Off Road)",
  "Moped",
  "Motorized Scooter",
  "Motorized Tricycle",
  "Motorcycle with Sidecar",
  "Race Car",
  "Snowmobile",
  "Snowmobile with Sled",
  "Travelling Motor Home (Primary Residence)",
  "Jeep",
  "Private Passenger - Convertible",
  "Private Passenger - 2 Door Sedan/Hard Top",
  "Private Passenger - 3 Door Hatchback",
  "Private Passenger - 4 Door Sedan/Hard Top",
  "Private Passenger - 4 Door Hatchback",
  "Private Passenger - Station Wagon",
  "Bike / Mini-Bike Trailer",
  "Mix In Transit Trailer",
  "Office Trailer",
  "Pup Trailer",
  "Semi-trailer Extra Trailer",
  "Stake/Platform Trailer Hauled",
  "Stake/Platform Trailer Train",
  "Tank Trailer Hauled As Train",
  "Tank Trailer Hauled Separately",
  "Trailer - Other Load Carrying",
  "Trailer With Premises Exposure (e.g. Showroom, etc.)",
  "Van Trailer Hauled As Train",
  "Van Trailer Hauled Separately",
  "Watercraft Trailer",
  "Snowmobile Trailer",
  "Livestock Trailer",
  "Converter Dolly",
  "Dump Trailer Hauled Separately",
  "Dump Trailer Hauled As Train",
  "Equipment Trailer Hauled Separately",
  "Equipment Trailer Hauled As Train",
  "Gooseneck Trailer",
  "Horse Trailer",
];

export const AUTOMOBILE_CSIO_OTHER_COVERAGE_REVERSE = [
  "Bodily Injury",
  "Property Damage",
  "Accident Benefits (Standard Benefits)",
  "Income Replacement ($600/$800/$1,000)",
  "Medical Rehabilitation & Attendant Care ($130,000/$1,000,000)",
  "Optional Catastrophic Impairment(additional $1,000,000 added to Standard Benefit or Optional Medical, Rehabilitation & Attendant Care Benefit)",
  "Caregiver, Housekeeping & Home Maintenance",
  "Death & Funeral",
  "Dependent Care",
  "Indexation Benefit (Consumer Price Index)",
  "Uninsured Automobile",
  "Direct Compensation-Property Damage",
  "Specified Perils (excluding Collision or Upset)",
  "Comprehensive (excluding Collision or Upset)",
  "Collision or Upset",
  "All Perils",
  "Policy Change Forms (Name & No.)Family Protection Coverage - OPCF 44R",
  "NBEF2 - Drive Other Automobiles - Named Person(s), OPCF2 - Providing Coverage When Named Persons Drive Other Automobiles, QEF2 - Drive Other Automobiles - Named Person(s), SEF2 - Drive Other Automobiles - Named Person(s), AB-SEF2 - Designated Operator(s) Drive Other Automobiles Endorsement",
  "NBEF3 - Drive Government Automobiles, OPCF3 - Drive Government Automobiles, QEF3 - Drive Government Automobiles, SEF3 - Drive Government Automobiles, AB-SEF3 - Drive Government Automobile Endorsement",
  "ASEF5 - Permission to Rent or Lease (Specified Lessee), OPCF5 - Permission to Rent or Lease Automobiles and Extending Coverage to the Specific Lessee(s), SEF5 - Permission to Rent or Lease, EEF5 Permission to Rent or Lease",
  "NBEF7 - Separate Limits (Third Party Liability), OPCF7 - Separate Limits (Liability), SEF7 - Separate Limits (Third Party Liability)",
  "ASEF8 - Property Damage Reimbursement (Section A Only), OPCF8 - Property Damage Reimbursement, QEF8 - Deductible Property Damage, SEF8 - Property Damage Reimbursement (Section A Only)",
  "NBEF9 - Marine Use Excluded (Amphibious Vehicles), OPCF9 - Marine Use Excluded (Amphibious Automobiles), QEF9 - Marine Use Excluded (Amphibious Automobiles), SEF9 - Marine Use Excluded (Amphibious Vehicles), AB-SEF9 - Marine Use Excluded Endorsement (Amphibious Vehicles)",
  "SEF10 - Limitation of coverage",
  "SEF11 - Change of Coverages (Section C)",
  "SEF12 - Additional Coverage",
  "SEF14 - Addition of Automobile",
  "NBEF16 - Agreement for Suspension of Coverage, OPCF16 - Suspension of Coverage, QEF16 - Suspension for Storage, SEF16 - Agreement for Suspension of Coverage, AB-SEF16 - Suspension of Coverages Endorsement",
  "NBEF17 - Reinstatement of Coverage, OPCF17 - Reinstatement of Coverage, QEF17 - Reinstatement After Storage, SEF17 - Reinstatement of Coverage, AB-SEF17 - Reinstatement of Coverages Endorsement",
  "SEF18 - Replacement Cost Endorsement, AB-SEF18 - Replacement Cost Endorsement",
  "NBEF19 - Limitation of Amount, OPCF19 - Limitation of Amount Paid forLoss or Damage Coverages, QEF19 - Section B - Limitation of Amount, SEF19 - Limitation of Amount, EEF19 Limitation of Amount",
  "NBEF20 - Loss of Use, OPCF20 - Coverage for Transportation Replacement, QEF20 - Travel Expenses, SEF20 - Loss of Use, EEF20 Loss of Use Coverage, AB-SEF20 - Loss of Use Endorsement",
  "NBEF22 - Damage to Property of Passengers , OPCF22 - Damage to Property of Passengers, SEF22 - Damage to Property of Passengers, AB-SEF22 - Damage to Property of Passengers Endorsement",
  "NBEF24 - Fire Apparatus , OPCF24 - Fire Apparatus, QEF24 - Fire Apparatus Limitation, SEF24 - Fire Apparatus, AB-SEF24 - Fire and Rescue Equipment Endorsement",
  "NBEF25 - Alteration Endorsement, OPCF25 - Replaced by OPCF25A, QEF25 - Modified Declarations, SEF25 - Alteration Endorsement (endorsement changing or correcting statement(s) in the application or changing the rating classification)",
  "NBEF26 - Disappearing Deductible (All Perils or Collision), OPCF26 - There is no such endorsement, SEF26 - Disappearing Deductible (All Perils or Collision)",
  "ASEF27 - Legal Liability for Damage to Non-owned Automobile, OPCF27 - Liability for Damage to Non-owned Automobile(s) and Providing Other Coverages When Insured Persons Drive Other Automobiles, QEF27 - Civil Liability Resulting from Damage to Non Owned Automobiles INCLUDING Automobiles Provided by an Employer, SEF27 - Legal Liability for Damage to Non owned Automobiles",
  "NBEF28 - Reduction of Coverage as Respects Operation by Named Person(s), OPCF28 - Reduction of Coverage for Named Persons, QEF28 - Reduction of Coverage for Named Drivers, SEF28 - Reduction of Coverage as Respects Operation by Named Person(s), EEF28 Excluded Named Person",
  "NBEF29 - Additional Coverage as Respects Operation by Named Person(s), OPCF29 - Additional Coverage for Named Persons , QEF29 Additional Coverage for Named Drivers, SEF29 - Additional Coverage as Respects Operation by Named Person(s), AB-SEF29 - Named Person(s) Additional Coverage Endorsement",
  "NBEF30 - Excluding Operation of Attached Machinery, OPCF30 - Excluding Operation of Attached Machinery, QEF30 - Attached Machinery Limitation, SEF30 - Excluding Operation of Attached Machinery",
  "NBEF31 - Non-owned Equipment, OPCF31 - Non owned Equipment, QEF31 - Non-owned Equipment, SEF31 - Non owned Equipment, AB-SEF31 - Non-Owned Equipment Endorsement ",
  "NBEF32 - Recreational Vehicle, OPCF32 - Use of Recreational Vehicles by Unlicensed Operators, QEF32 - Recreational Vehicle, SEF32 - Recreational Vehicle, AB-SEF32 - Off-Highway Vehicle Endorsement",
  "QEF33 - Emergency Service Expense Coverage, SEF33 - Accident Benefits Pedestrian Coverage",
  "QEF34 - Accident Benefits, SEF34 - Accident Benefits Coverage - Insured Person Defined - Custodians Endorsement",
  "ASEF35 - Emergency Service Expense, OPCF35 - Coverage for Emergency Road Service, SEF35 - Emergency Service Expense, AB-SEF35 - Emergency Service Expense Endorsement",
  "NBEF36 - Commercial Automobiles Used Exclusively for Pleasure, SEF36 - Commercial Automobile Used Exclusively for Pleasure",
  "ASEF37 - Limitation to Automobile Sound and Electronic Communication Equipment, SEF37 - Limitation to Automobile Sound and Electronic Communication Equipment, AB-SEF37 - Limitation to Automobile Electronic Accessories and Electronic Equipment Endorsement",
  "ASEF38 - Increased Limit, Automobile Sound and Electronic Communication Equipment, OPCF38 - Agreed Limit for Automobile Electronic Accessories and Equipment, SEF38 - Increased Limit, Automobile Sound and Electronic Communication Equipment, AB-SEF38 - Specified Limit(s) – Automobile Electronic Accessories and Electronic Equipment Endorsement",
  "SEF39 - Accident Rating Waiver",
  "NBEF40 - Fire and Theft Deductible, OPCF40 - Fire and Theft Deductible, QEF40 - Fire Deductible, SEF40 - Fire and Theft Deductible, AB-SEF40 - Fire and Theft Deductible Endorsement",
  "QEF41 Endorsement Modifying the Deductibles indicated in the Declarations, OPCF41 - Endorsement Modifying the Deductibles indicated in the Declarations,SEF41 - Endorsement Modifying the Deductibles indicated in the Declarations",
  "OPCF43 - Removing Depreciation Deduction, EEF43 Replacement Cost Coverage",
  "NBEF44 - Family Protection, QEF44 - Territory Extension, SEF44 - Family Protection, EEF44 Family Protection Coverage, AB-SEF44 - Family Protection Endorsement ",
  "QEF45 - Warranty Applicable to Theft of the Entire Automobile",
  "OPCF46 - Pre-determined Income from Self-employment Agreement, EEF46 Notice of Cancellation",
  "OPCF47 - Agreement Not to Rely on SABS Priority of Payment Rules",
  "SEF48 - Optional Supplementary Benefits Section B - Accident Benefits (Nova Scotia only)Added Coverage to Offset Tort Deductibles Endorsment (Ontarioonly)",
  "OPCF 49 - Agreement Not to Recover for Loss or Damage from an Automobile Collision (for Ontario Automobile Policy OAP 1)",
  "ASEF62 - Agreement to Provide Coverage Under Section C",
  "ASEF63 - Loss of Use Motor Home and Vacation Travel Trailer Emergency Accommodation Expense",
  "O.E.F. 87 - Added Coverage to Offset Tort Deductibles (for Ontario Garage Automobile Policy O.A.P. 4)",
  "SEF99- Excluding Long Term Leased Vehicle Endorsement, AB-SEF99- Leased Vehicle Exclusion Endorsement (For attachment only to a Non-Owned Automobile Insurance Policy S.P.F. No. 6)",
  "EEF103 Excess Value Endorsement",
  "EEF110 Environmental Liability Limitations",
  "EEF113 Approved Drivers Warranty",
  "EEF114 Restoration Endorsement",
  "EEF115 Repair Endorsement",
  "SEF13a - Deletion of Automobile",
  "SEF13b - Deleted Coverage",
  "NBEF13c - Comprehensive Cover - Deletion of Glass, OPCF13c - Restricting Glass Coverage, QEF13c - Comprehensive Cover - Deletion of Glass,SEF13c - Comprehensive Cover Deletion of Glass",
  "SEF13d - Comprehensive Cover Limited Glass, AB-SEF13(D) - Limitation of Glass Coverage Endorsement",
  "OPCF13h - Deletion of Hail Coverage, SEF13h - Section C - Deletion Hail Coverage, AB-SEF13(H) - Existing Hail Damage - Deletion of Hail Coverage Endorsement",
  "SEF13S Glass Deleted",
  "SEF15a - Substitution of Automobile (no change in coverage)",
  "SEF15b - Combined Substitution of Automobile and Deleted Coverage",
  "SEF15c - Combined Substitution of Automobile and Additional Coverage",
  "NBEF19a - Valued Automobile(s), OPCF19a - Agreed Value of Automobiles, SEF19a - Valued Automobile(s), EEF19a Stated Value, AB-SEF19(A) - Valued Automobile Endorsement",
  "QEF20a - Travel Expenses (Broad Form), EEF20a Liability for Loss of Use",
  "OPCF21b - Blanket Fleet Coverage for Ontario Licensed Automobiles, QEF21b - Blanket Basis Fleet (Annual Premium Adjustment), SEF21b - Blanket Basis Fleet, EEF21b Blanket Basis Fleet, AB-SEF21(B) - Blanket Basis Fleet Endorsement",
  "SEF21d - Excess Coverage for Blanket Basis Fleet, EEF21d Blanket Excess Value, AB-SEF21(D) - Blanket Basis Fleet Omission Endorsement",
  "NBEF23a - Mortgage Endorsement, OPCF23a - Lienholder - For use with OAP No. 1 Owner's Form, QEF23a - Notice to Creditor, SEF23a - Mortgage Endorsement, AB-SEF23(A) - Lienholder, Mortgagee or Assignee Endorsement",
  "NBEF23b - Mortgage Endorsement (Broad Form), OPCF23b - Mortgage (Broad Form) - For use with OAP No. 1 Owner's Form , QEF23b - Creditor Coverage, SEF23b - Mortgage Endorsement (Broad Form), AB-SEF23(B) - Lienholder, Mortgagee Or Assignee Endorsement (Broad Form)",
  "NBEF25a - Alteration Endorsement, OPCF25a - Alteration Endorsement, SEF25a - Alteration Endorsement, AB-SEF25(A) - Alteration Endorsement",
  "QEF27a - Civil Liability Resulting from Damage to Non owned Automobiles EXCLUDING Automobiles Provided by an Employer, EEF27a Legal Liability for Damage to Non-Owned Automobiles",
  "ASEF27B - Legal Liability for Damage to Non-owned Automobile, OPCF27b - Business Operations - Liability for Damage to Non-owned Automobile(s) in Your Care, Custody or Control",
  "OPCF28a - Excluded Driver, SEF28a - Reduction of Coverage as Respects to Operation on Airport Property, AB-SEF28(A) - Reduction of Coverage when Automobile Operated on Airport Property Endorsement",
  "SEF30a - Excluding Attached Machinery, AB-SEF30(A) Attached Machinery, Apparatus or Equipment Exclusion Endorsement: Sections A.1 and C",
  "EEF32a Snowmobile Underage Operator",
  "ATV Underage Operator",
  "Motorcycle Underage Operator",
  "QEF34a - Accident Benefits (Change of Amounts or insured persons - when the insured is an Individual)",
  "DEPRECATED QEF34a-b - Accident Benefits (Change of Amounts or insured persons)",

  "QEF34b Accident Benefits (Change of Amounts or insured persons - when the insured is a  Legal Person, Partnership or Association",
  "QEF37a - Modified Coverage on Electronic Equipment - Limitation of Amount",
  "QEF37b - Modified Coverage on Electronic Equipment - Exclusion of Equipment",
  "SEF39B - Designated Operator Traffic Safety Conviction Rating Waiver Endorsement, AB-SEF39(B) - Designated Operator Minor Traffic Safety Conviction Rating Waiver Endorsement",
  "OPCF43a - Removing Depreciation Deduction for Specified Lessee(s), QEF43a - Change to Loss Payment – Partial Loss – New Parts",
  "Change to Loss Payment - Partial Loss - Waiver of Depreciation",
  "Change to Loss Payment - Total Loss - Agreed Amount",
  "Change to Loss Payment - Total Loss - Waiver of Depreciation",
  "Change to Loss Payment - Total Loss - Replacement Cost",
  "Change to Loss Payment - Total Loss - Increased Settlement",
  "EEF43l Limited Waiver of Depreciation",
  "Replacement Cost (Owned)",
  "NBEF43r - Limited Waiver of Depreciation, SEF43r - Limited Waiver of Depreciation, AB-SEF43R - Limited Waiver of Depreciation",
  "ASEFr(L) - Limited Waiver of Depreciation (Specified Lessee), OPCF43r(L) - Limited Waiver of Depreciation (Specified Lessee), SEF43r(L) - Limited Waiver of Depreciation (Specified Lessee), AB-SEF43R(L) Specified Lessee Limited Waiver of Depreciation Endorsement",
  "Replacement Cost (Specified Lessee)",
  "QEF 4-41 Endorsement Modifying the Deductibles indicated in the Declarations",
  "OPCF44R - Family Protection Coverage",
  "NBEF4a - Permission to Carry Explosives, OPCF4a - Permission to Carry Explosives, QEF4a - Transportation of Explosives, SEF4a - Permission to Carry Explosives, EEF4a Permission to Carry Explosives, AB-SEF4(A) - Permission to Carry Explosives Endorsement",
  "NBEF4B - Permission to Carry Radioactive Material, OPCF4b - Permission to Carry Radioactive Material, QEF4b - Transportation of Radioactive Material, SEF4b - Permission to Carry Radioactive Material, EEF4b Permission to Carry Radioactive Material, AB-SEF4(B) - Permission to Carry Radioactive Materials Endorsement",
  "OPCF5a - Replaced by OPCF #5, QEF5a - Lease or Leasing - Amended Q.P.F. No. 1 When Owner and One Lessee Shown as Named Insureds",
  "OPCF5b - Permission to Rent or Lease (Specified Lessee and Modified Declarations - Master Policy)",
  "NBEF5c - Permission to Rent or Lease (Unspecified Lessees - Short Term Leases Only), OPCF5c - Permission to Rent or Lease (Unspecified Lessees - Short Term Leases Only), QEF5c - Rented Automobile (Unspecified Lessees - Short Term Only), SEF5c - Permission to Rent or Lease, AB-SEF5(C) - Permission to Rent Endorsement",
  "Permission To Rent Or Lease The Vehicle For Carsharing (5CS)",
  "NBEF5d - Conversion Coverage (Rented or Leased Automobiles), OPCF5d - Conversion Coverage (Rented or Leased Automobiles), QEF5d - Conversion Coverage (Rented or Leased Automobiles), SEF5d - Conversion Coverage, AB-SEF5(D) - Conversion Coverage Endorsement",
  "NBEF6a - Permission to Carry Passengers for Compensation, OPCF6a - Permission to Carry Paying Passengers, SEF6a - Permission to Carry Passengers for Compensation, EEF6a Permission to Carry Passengers, AB-SEF6(A) - Carry Passengers for Compensation or Hire Endorsement",
  "NBEF6b - School Bus, OPCF6b - School Bus, SEF6b - School Bus - For use on SPF No. 11, AB-SEF6(B) - School Transportation Endorsement",
  "OPCF6c - Public Passenger Vehicles, SEF6c - Public Passenger Vehicles, AB-SEF6(C) - Public Passenger Automobile Enhanced Coverage Endorsement",
  "NBEF6d - Driver Training School, OPCF6d - Driver Training School, SEF6d - Driver Training School, AB-SEF6(D) - Driver Training Services Endorsement",
  "OPCF6e - No longer in use, SEF6e - Employees Business Use",
  "NBEF6f - Public Passenger Vehicles, OPCF6f - Public Passenger Vehicles - Combined Limits, SEF6f - Public Passenger Vehicles, AB-SEF6(F) - Public Passenger Automobile Endorsement",
  "ASEF8a - Property Damage Reimbursement for Operation by Named Person - (Section A Only), QEF8a - Deductible Civil Liability, SEF8a - Property Damage Reimbursement for Operation by Named Person, AB-SEF8(A) - Named Person Property Damage Reimbursement Endorsement (Section A – Third Party Liability)",
  "SEF98B- Reduction of Coverage for Lessees or Drivers of Leased Vehicles Endorsement ",
  "Accident Benefits",
  "Accident Benefits Occasional Driver",
  "Attendant Care Benefits",
  "Attendant Care for Occasional Driver",
  "Accidental Death Benefits",
  "After-marketAccessories",
  "Attached Machinery - Property Damage Reimbursement",
  "Animal or Bird Collision Deductible",
  "All Perils",
  "All Perils Occasional Driver",
  "Deletion of Hail Coverage – without pre-existing damage",
  "Hail Deductible",
  "CATIM, CHHMB",
  "CATIM, DCB",
  "Catastrophic Impairment",
  "Catastrophic Impairment (Occasional Driver)",
  "Coverage under section C for contents of described Motorhome or Vacation Trailer. ",
  "Cancellation/Deletion of Coverage Endorsement",
  "Endorsement for change in deductible notice ",
  "Cellular Telephone",
  "Caregiver, Housekeeping & Home Maintenance Benefits, and Dependant Care Benefits",
  "Caregiver, Housekeeping & Home Maintenance Benefits",
  "Caregiver, Housekeeping & Home Maintenance for Occasional Driver",
  "Catastrophic Impairment - Medical, Rehabilitation and Attendant Care (Occasional Driver)",
  "Catastrophic Impairment - Medical, Rehabilitation and Attendant Care",
  "Claims advantage",
  "Classic Vehicle",
  "Comprehensive",
  "Collision",
  "Collision Occasional Driver",
  "Collector Vehicle",
  "Claims Protection Plan",
  "Claims Protection Plan - Extended",
  "Claims Protection Plan - Occasional Driver",
  "Claims Protection Plan - Used",
  "Dependant Care Benefits",
  "Dependant Care for Occasional Driver",
  "Declared Value",
  "Death and Funeral Benefits",
  "Death & Funeral for Occasional Driver",
  "Death and Funeral Income Replacement",
  "Abstain from Alcohol",
  "Discount - Autonomous Emergency Braking System",
  "Discount - Anti Theft Device Automatically Activated (non alarms)",
  "Discount - Alarm System",
  "Discount - Association/Membership",
  "Discount - Away - at - School",
  "Discount - Antique Vehicle",
  "Discount - Authorized Vendors",
  "Broker Multi Line Discount",
  "Basic Policy (No Frills)",
  "Broker Self Service",
  "Discount - Conviction Free",
  "Discount - Religious Clerical",
  "Discount - No. of Comprehensive Claims ",
  "Discount - Conviction Free (Occasional Driver)",
  "Discount - Combined Policy",
  "Discount - Credit Consent Received",
  "Risk Premium Cap",
  "Discount - Driver Age",
  "Risk Discount Cap",
  "Discount - Anti Theft Device Manually Activated (non alarms)",

  "Discount - Group Rate Applied for Occasional Driver",
  "Discount - Insured's Driving Record",
  "Discount - Driving Simulator",
  "Discount - Driver Training",
  "Discount - Experienced Driver",
  "Discount for Electric car",
  "Discount - Employee",
  "Discount – Excess Trailer",
  "Discount - Facility",
  "Discount - Farm Comprehensive",
  "Discount - Female",
  "Discount - Claims Forgiveness",
  "Discount - Farm",
  "Discount- Family ",
  "Discount - Group Rate Applied",
  "Discount - Underage classes provided a parents’ private passenger automobile(s) is insured with the same company and at least one private passenger automobile carries mandatory coverages.",
  "Discount - Graduated License for an Occasional Driver",
  "Discount - Graduated License Holder",
  "Discount - Good Student",
  "Discount - Higher Limit Purchased",
  "Discount - Hybrid",
  "Discount - I Promise Program-Parent/Teen Mutual Safe Driving Contract",
  "Discount - Low Commute Distance",
  "Discount - Low Annual Mileage",
  "Discount - Miscellaneous",
  "Discount - Mortgage Free Home/Condominium ",
  "Discount - Motor Home",
  "Motor Home",
  "Discount - Mature Driver",
  "Multi Motorcycle Discount",
  "Motorcycle Improvement Course",
  "Discount - Multiple Line ",
  "Discount - Marital Status",
  "Discount - Multi Vehicle",
  "Discount - Non Authorized Vendors",
  "Discount New Business",
  "Discount - No Claims",
  "Discount - New Driver",
  "Discount - No Claims (Occasional Driver)",
  "Discount - Non-smoker",
  "Discount - New Vehicle",
  "Discount - Occupation",
  "Discount - Occasional Driver",
  "Discount - Facility (Occasional Driver)",
  "Discount - Out of Province",
  "Discount - Facility-Occasional Driver (Remedial Driver Improvement Course)",
  "Discount - Owner of Vehicle",
  "Discount - Private Parking",
  "Discount - Professional",
  "Discount - Partial workweek commute",
  "Discount - Range of Operations",
  "Discount - Recreational vehicle combined with a private passenger vehicle",
  "Discount - Retiree",
  "Discount - Facility - Regular Driver (Remedial Driver Improvement Course)",
  "Discount - Renewal",
  "Discount - Renewal (Occasional)",
  "Discount – Multi Recreational Vehicle",
  "Discount - Senior Citizen (Age Related)",
  "Discount - Snow Tires",
  "Select Rider Discount ",
  "Discount - Stability",
  "Discount - Electronic Stability Control System (Factory Equipped)",
  "Discount - Trail Permit",
  "Discount - Territory",
  "Total Discount Applied",
  "Discount - Valued/Preferred Customer",
  "Discount-Vehicle to Operator Ratio",
  "Discount Young Driver",
  "Driving Record Guarantee After Loss",
  "Driving Record Guarantee Before Loss",
  "Flatbed Towing Expense",
  "Restrict Hail Damage to Punctures",
  "Health Services Levy",
  "Indexation",
  "Indexation Benefit for Occasional Driver",
  "Loss of Use Motorhome and Vacation Trailer Emergency Accommodation Expense Endorsement",
  "Waiver of Deductible",
  "Caregiver, Housekeeping & Home Maintenance Benefits, Medical & Rehabilitation Benefits, and Attendant Care Benefits",
  "Manitoba only - Cancellation/Deletion of Coverage Endorsement",
  "Manitoba only - Loss of Rental Income",
  "Manitoba only - Value Plus ",
  "Manitoba only - Vehicle Lay-up",
  "Manitoba only - Value Plus - Specified Lessee",
  "Minor Conviction Protection",
  "Minor Conviction Protection for Occasional Driver",
  "Minor Conviction Protection for Occasional Driver - Used",
  "Minor Conviction Protection - Used",
  "Medical Expenses",
  "Medical & Rehabilitation Benefits",
  "Medical & Rehabilitation Benefits, and Attendant Care Benefits, and Dependant Care Benefits",
  "Agreed Limit for Motorcycle Accessories and Equipment",
  "Motorcycle - Vacation Expense",
  "Medical, Rehabilitation & Attendant Care",
  "Medical, Rehabilitation and Attendant Care for Occasional Driver",
  "Medical & Rehabilitation for Occasional Driver",
  "Driving Record Guarantee Before After (Occasional Driver)",
  "Driving Record Guarantee Before Loss (Occasional Driver)",
  "Off Road Use",
  "One Deductible Endorsement",
  "Overnight Accommodation",
  "20 (or 20A), 35, 43 (or 43A or 43R or 43RL)",
  "27, 35, 43 (or 43A or 43R or 43RL) ",
  "20 (or 20A), 43 (or 43A or 43R or 43RL)",
  "20 (or 20A), 35 ",
  "20 (or 20A), 27, 43 (or 43A or 43R or 43RL) ",
  "20 (or 20A), 27 ",
  "20 (or 20A), 27, 34 ",
  "20 (or 20A), 27, 35, 43 (or 43A or 43R or 43RL)",
  "20 (or 20A), 27, 35 ",
  "2, 20 (or 20A), 43 (or 43A or 43R or 43RL)",
  "2, 20A, 27 and 34 ",
  "2, 20, 27 and 34 ",
  "2, 20 (or 20A), 27 ",
  "2, 20 (or 20A), 27 and 43 (or 43A or 43R or 43RL)",
  "18, 20 (or 20A), 27, 35",
  "SRAP, 20, 27, 43",
  "SRAP, 20, 27",
  "Premium Adjustment Reporting Form",
  "Personal Protective Equipment (excluding personal effects)",
  "Personal Effects (excluding Personal Protective Equipment)",
  "License/Permit Charge",
  "Death Benefits and Dismemberment",
  "Restoration while in Storage",
  "Road Hazard Glass",
  "Renewal Rate Protection",
  "Specified Perils",
  "Spare Parts",
  "Enhanced Roadside Assistance Program",
  "Short Term Cancellation Table",
  "Combined Driver Age/Risk Type Surcharge",
  "Surcharge - Antique Vehicle",
  "Surcharge - Business Use",
  "Surcharge – Conviction/Claim",
  "Surcharge - Prior Policy Cancellation",
  "Surcharge - Claims for Occasional Driver (class 06/05)",
  "Surcharge - Convictions for Occasional Driver (class 06/05)",
  "Surcharge - Commercial Exposure",
  "Surcharge - Claims",
  "Surcharge - No. of Comprehensive Claims",
];

export const CSIO_DRIVER_RELATIONSHIP_REVERSE = [
  "Partner, Same-sex",
  "Common Law Spouse",
  "Brother/Sister",
  "Child",
  "Employee",
  "Co habitant",
  "Insured",
  "Lessee",
  "Other",
  "Parent",
  "Other Relative",
  "Spouse",
  "Third Party",
];

export const CSIO_POLICY_NAME_REVERSE = [
  "Renewal",
  "Cancelled",
  "Cancellation Pending",
  "Electronic Document Transfer",
  "Expired Policy Term",
  "Incomplete",
  "Lapsed",
  "Lapse Pending",
  "New Business (Active/In Force)",
  "New Business (Bound/Awaiting Issue)",
  "New Business (Quoted)",
  "New Business (Issued)",
  "New Business (Not Quoted)",
  "Policy Change (Draft)",
  "Policy Change (Quoted)",
  "Policy Change/Endorsement ",
  "Renewed (Issued) ",
  "Reinstated (Active/In Force)",
  "Renewed (Active/In Force)",
  "Renewal (Quoted)",
  "Reinstatement (Draft)",
  "Reinstatement (Quoted)",
  "Renewing (Draft)",
  "Locked/Suspended",
  "Withdrawn ",
  "Cancellation (Flat)",
];
// purchase con
export const AUTOMOBILE_CSIO_NEWUSED_REVERSE = [
  "New",
  "Used",
  "Demonstrator",
  "Reconstructed",
];
// fuel type
export const AUTOMOBILE_CSIO_ENGINE_REVERSE = [
  "Diesel",
  "Electric (Battery)",
  "Gasoline",
  "Natural Gas",
  "Propane (Not-factory Installed)",
  "Propane (Factory Installed)",
  "Solar",
  "Alcohol",
  "Electric (Fuel Cell)",
  "Gasoline and Electric",
  "Other",
];
// vehicle use
export const AUTOMOBILE_CSIO_VEHICLE_USE_REVERSE = [
  "Pleasure",
  "Commercial",
  "Commute",
  "Business",
  "Farm",
];

export const CSIO_ANTI_THEFT_DEVICE_CODE_LIST = [
  "None",
  "Electronic Alarm (Audible)",
  "Engraving",
  "Startup Blockage Mechanism with Deactivator",
  "Steering Blocking Bar",
  "Tracking System",
  "Other",
  "Ignition, Siren and Sensor",
  "Steering Column Armored Collars",
  "Monitored",
  "Fuel Disable",
  "Impact",
  "Original Manufacturer Anti-theft Package",
  "Manual Arming Independent of Central Locking System",
  "Motion Sensor",
  "Tire Locks",
];

export const YesNO = [
  { label: "Y", value: "Y" },
  { label: "N", value: "N" },
];

export const CSIO_ANTI_THEFT_ENGRAVING_DEV_MFR_CD = [
  "Autograph",
  "Automobile Manufacturer",
  "Sherlock",
  "Other",
  "None",
  "Autoluck",
  "DataDot",
  "Guardian",
  "Larlock",
  "Microdot",
  "Otoprotec",
  "Tao",
  "TAG",
  "Vin Lock",
  "Domino",
];
// interested party interest
export const CSIO_NATURE_INTEREST_CODE_LIST = [
  "Accounting Contact",
  "Additional Interest",
  "Attorney in Fact",
  "Additional Insured",
  "Additional Lessor",
  "Actual Owner",
  "Assignee",
  "Broker/Dispatcher",
  "Building Owner",
  "Certificate Holder",
  "Canadian",
  "Corporate Owner",
  "Cohabitant/Co-Occupant",
  "Escrow Corporation",
  "Executor",
  "Finance Company",
  "Inspection Contact",
  "Line of Credit",
  "Lienholder",
  "Loss Payee",
  "Lessor",
  "Mortgagee (Financial Institution)",
  "Mortgagee (Other)",
  "Mortgage Servicing Agency",
  "Municipality",
  "Other",
  "Both Loss Payee and Additional Insured",
  "Registered Owner",
  "Secured Loss Payee",
  "Tenant",
  "Taxi Plate Owner",
];

// vehicle type
export const AUTOMOBILE_CSIO_VEHICLE_TYPE = [
  "Private Passenger",
  "Private Passenger with Driver",
  "Commercial",
  "Commercial with Driver",
  "Trailer -Open",
  "Trailer -Closed, Non-refrigerated",
  "Trailer -Closed, Refrigerated",
  "Trailer -Pup",
  "Trailer -Dump",
  "Trailer -Tanker",
  "Trailer -Flatbed",
  "Unlicensed Auto",
  "Unlicensed Recreational Vehicle",
  "Unlicensed Trailer",
  "Unlicensed Truck",
  "Bus",
  "Commercial Vehicle",
  "Unknown",
  "None",
  "Other",
];

// Habitational start
export const CSIO_WIRING_TYPE_REVERSE = [
  "Aluminium",
  "Copper",
  "Knob and Tube",
  "Mixed",
  "Other ",
  "None - Not Wired",
  "Unknown",
  "Combination - Aluminum and Copper",
  "Metal Clad",
  "Non-metallic Sheathed",
];

export const CSIO_FOUNDATION_TYPE_REVERSE = [
  "Concrete/Masonry",
  "On Blocks",
  "On Wheels",
  "On Timber",
  "Post/Pier on Slab",
  "Basement",
  "Crawlspace",
  "Slab/Concrete Slab",
  "Other",
  "Brick",
  "Concrete Blocks",
  "Poured Concrete",
  "Reinforced Concrete",
  "Stone",
];

export const CSIO_ELECTRICAL_PANEL_REVERSE = [
  "Aluminium",
  "Copper",
  "Knob and Tube",
  "Mixed",
  "Other ",
  "None - Not Wired",
  "Unknown",
  "Combination - Aluminum and Copper",
  "Metal Clad",
  "Non-metallic Sheathed",
];

export const CSIO_OCCUPANCT_TYPE_REVERSE = [
  "Primary Residence",
  "Secondary, Non-seasonal",
  "Secondary, Seasonal",
  "Rental",
  "Not Applicable",
  "Unoccupied",
  "Vacant",
  "Rented to Third Party",
  "Under Construction",
  "Employee Occupied",
  "Major Renovation",
  "Other",
];

export const CSIO_ROOF_MATERIAL_REVERSE = [
  "Unknown",
  "None/Not Applicable",
  "Other",
  "Asphalt Shingles",
  "Aluminium",
  "Clay Tile",
  "Laminated Shingles",
  "Elastomeric",
  "Mineral Fiber Shakes",
  "Green Roof",
  "Corrugated Steel",
  "Metal Tile",
  "Concrete Tile",
  "Other Tile",
  "Plastic",
  "Asphalt Roll",
  "Slate Tile",
  "Tar and Gravel",
  "Rubber",
  "Wood Shakes",
  "Wood Shingles",
];

export const CSIO_DWELL_USE_CODE = [
  "Primary Residence",
  "Secondary, Non seasonal",
  "Secondary, Seasonal",
  "Rental",
  "Not Applicable",
  "Unoccupied",
  "Vacant",
  "Rented To Third Party",
  "Under Construction",
];

export const CSIO_EXTERIOR_WALL_FINISH_TYPE_CODE = [
  "Unknown",
  "Thin Brick Siding",
  "Monocoque",
  "Fiberglass",
  "Metal Siding",
  "Same as construction type",
  "Other",
  "Asbestos",
  "Cement",
  "Cement Fiber Board",
  "Aggregate",
  "Cement Fiber Shingle",
  "Cedar Siding",
  "Aluminium",
  "Stucco",
  "Log Siding",
  "Stone Veneer",
  "Wood Exterior",
  "Brick Veneer",
  "Vinyl",
];

export const CSIO_FUEL_TYPE_REVERSE = [
  "Oil/Wood",
  "Butane",
  "Coal",
  "Wind",
  "Electric/Wood",
  "Ethanol/Alcohol",
  "Naphta Gas",
  "Recycled Oil",
  "Oil",
  "Kerosene",
  "Liquefied Petroleum Gas",
  "Combination - other",
  "Natural Gas",
  "Other",
  "Propane",
  "Solar",
  "Other Solid Fuel",
  "Pellet",
  "Grain",
  "Steam",
  "Wood",
  "Electric/Oil",
  "Electric",
  "Diesel",
];

export const CSIO_ACCESS_CODE = [
  "Easy Access Road",
  "Difficult Access Road",
  "Island",
  "Isolated Rural",
  "Other",
];

export const CSIO_SUMP_PUMP_TYPE_CODE = [
  "Floor Sucker (Electric)",
  "Pedestal (Electric)",
  "Submersible (Electric)",
  "Water Powered",
  "None",
  "Other",
];

export const CSIO_SUMP_PUMP_AUXILIARY_POWER_TYPE_CODE = [
  "Battery",
  "Generator",
  "None",
  "Other",
];
